<template>
  <div class='views'>
    <mvp :open='open' :type='"view"' :edit='edit'></mvp>
    <div class="items" v-show = 'open'>
      <item v-for="(item,index) in data" :key="index" :data='item' :type='"view"' :edit='edit' :level='1' :list='data' :model='model' :idx='index'></item>
    </div>
  </div>
</template>

<script>
import mvp from './components/mvp'
import item from './components/item'

export default {
  name: 'views',
  components: {
    mvp,
    item
  },
  props: {
    edit: {
      type: Boolean
    },
    data: {
      type: Array
    },
    open: {
      type: Boolean
    },
    model: {
      type: Array
    }
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.views{
  .items{
    float: left;
  }
}
</style>
